import React from 'react'

const Baby = () => (
  <svg
    height="512"
    viewBox="0 0 64 64"
    width="512"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="outline">
      <path d="m13 46.989v.011a1 1 0 0 0 .443.832c5.479 3.651 5.557 13.074 5.557 13.168a1 1 0 0 0 1 1h24a1 1 0 0 0 1-1c0-.095.063-9.507 5.555-13.168a1 1 0 0 0 .445-.832v-.011-29.208l7.242-1.811a1 1 0 0 0 .758-.97v-12a1 1 0 0 0 -1-1h-52a1 1 0 0 0 -1 1v12a1 1 0 0 0 .758.97l7.242 1.811v29.207zm3.941 1.344 9.294 1.033a13.054 13.054 0 0 0 -5.965 6.068 17.624 17.624 0 0 0 -3.329-7.101zm4.11 11.667a10.994 10.994 0 0 1 21.9 0zm22.679-4.566a13.054 13.054 0 0 0 -5.965-6.068l9.294-1.033a17.624 17.624 0 0 0 -3.329 7.101zm13.27-51.434v10.219l-6.239 1.56-2.524-11.779zm-10.809 0 1.274 5.941-6.027-5.941zm-8.274 0a6 6 0 0 1 -11.834 0zm-20.108 0h4.753l-6.027 5.941zm6.481 1.1a7.989 7.989 0 0 0 15.42 0l8.518 8.4.772 3.6v29l-17 1.894-17-1.889v-29l.772-3.6zm-17.29 9.119v-10.219h8.763l-2.524 11.779z" />
      <path d="m31 53h2v2h-2z" />
      <path d="m35 53h2v2h-2z" />
      <path d="m27 53h2v2h-2z" />
      <path d="m25.368 29.778 5.006 4.085a1 1 0 0 0 1.265 0l5.035-4.12a4.521 4.521 0 0 0 0-6.478 4.418 4.418 0 0 0 -5.663-.546 4.535 4.535 0 0 0 -5.643 7.059zm1.306-5.035a2.921 2.921 0 0 1 1.877-.822 2.5 2.5 0 0 1 1.756.8 1 1 0 0 0 1.374.012 2.5 2.5 0 0 1 3.645.01 2.535 2.535 0 0 1 .041 3.486l-4.362 3.571-4.331-3.533a2.526 2.526 0 0 1 0-3.522z" />
      <path d="m31 39a10.914 10.914 0 0 0 6.049-1.822l5.812.812a.986.986 0 0 0 1-.476 1 1 0 0 0 -.05-1.1l-2.811-3.841a11 11 0 1 0 -10 6.427zm0-20a9.01 9.01 0 0 1 9 9 8.892 8.892 0 0 1 -1.047 4.206 1 1 0 0 0 .076 1.059l1.771 2.418-3.857-.539a.977.977 0 0 0 -.719.176 9 9 0 1 1 -5.224-16.32z" />
      <path d="m19 15.414 3.707-3.707-1.414-1.414-4 4a1 1 0 0 0 -.293.707v2h2z" />
      <path d="m17 19h2v2h-2z" />
    </g>
  </svg>
)

export default Baby
